import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserAuthFacade } from '@state/user-auth';
import { MODAL_MESSAGE, ModalOpts } from './intro-modal.service';

@Component({
  selector: 'app-intro-modal',
  templateUrl: './intro-modal.component.html',
  styleUrls: ['./intro-modal.component.scss'],
  standalone: false,
})
export class IntroModalComponent {
  public data = inject<ModalOpts>(MAT_DIALOG_DATA);
  public dialogRef = inject(MatDialogRef<IntroModalComponent>);
  private readonly userAuthFacade = inject(UserAuthFacade);

  public additionalMessage = '';

  public MODAL_MESSAGE = MODAL_MESSAGE;

  public branding$ = this.userAuthFacade.branding$;

  public close(returnVal?: any): void {
    this.dialogRef.close(returnVal);
  }
}
